export type DropdownItem = {
  label: string;
  href: string;
};

export const categoryDropdownItems: Record<string, DropdownItem[]> = {
  Regional: [
    { label: "Dongbei", href: "/tags/eye-on-dongbei-series" },
    { label: "JiangZheHu", href: "/tags/eye-on-jiangzhehu-series" },
    { label: "Shandong", href: "/tags/eye-on-shandong-series" },
    { label: "Sichuan", href: "/tags/eye-on-sichuan-series" },
  ],

  Politics: [
    { label: "ASEAN", href: "/tags/asean" },
    { label: "China-US Relations", href: "/tags/china-us-relations" },
    { label: "Chinese Communist Party", href: "/tags/chinese-communist-party" },
    { label: "Cross-Strait Relations", href: "/tags/cross-strait-relations" },
    { label: "Governance", href: "/tags/governance" },
    { label: "International Relations", href: "/tags/international-relations" },
    { label: "Military", href: "/tags/military" },
    { label: "Soft Power", href: "/tags/soft-power" },
  ],
  Economy: [
    {
      label: "Belt and Road Initiative",
      href: "/tags/bri",
    },
    { label: "China-US Trade War", href: "/tags/china-us-trade-war" },
    { label: "Digital Currency", href: "/tags/digital-currency" },
    { label: "Domestic Consumption", href: "/tags/domestic-consumption" },
    { label: "Manufacturing", href: "/tags/manufacturing" },
    {
      label: "Property Market",
      href: "/tags/property-market",
    },
    {
      label: "Stock Market",
      href: "/tags/stock-market",
    },
    {
      label: "Supply Chain",
      href: "/tags/supply-chain",
    },
    { label: "Tariffs", href: "/tags/tariffs" },
    {
      label: "Transport",
      href: "/tags/transport",
    },
  ],

  Technology: [
    { label: "Artificial Intelligence", href: "/tags/artificial-intelligence" },
    { label: "China-US Tech War", href: "/tags/china-us-tech-war" },
    { label: "Cybersecurity", href: "/tags/cybersecurity" },
    { label: "Energy", href: "/tags/energy" },
    { label: "Hi-Tech Manufacturing", href: "/tags/hi-tech-manufacturing" },
    {
      label: "Innovation",
      href: "/tags/innovation",
    },
    {
      label: "Semiconductors",
      href: "/tags/semiconductors",
    },
    {
      label: "Space",
      href: "/tags/space",
    },
  ],

  History: [
    { label: "Cold War", href: "/tags/cold-war" },
    { label: "Colonialism", href: "/tags/colonialism" },
    { label: "Cultural Revolution", href: "/tags/cultural-revolution" },
    { label: "Memories", href: "/tags/memories" },
    {
      label: "Nanyang",
      href: "/tags/nanyang",
    },
    {
      label: "Second Sino-Japanese War",
      href: "/tags/second-sino-japanese-war",
    },
    {
      label: "World War II",
      href: "/tags/world-war-ii",
    },
  ],
  Society: [
    { label: "China workplace", href: "/tags/china-workplace" },
    { label: "China youths", href: "/tags/china-youths" },
    { label: "Education", href: "/tags/education" },
    { label: "Entertainment", href: "/tags/entertainment" },
    { label: "Family", href: "/tags/family" },
    { label: "Gender", href: "/tags/gender" },
    { label: "Involution", href: "/tags/involution" },
    { label: "Marriage", href: "/tags/marriage" },
    {
      label: "Population",
      href: "/tags/population",
    },
    {
      label: "Social Media",
      href: "/tags/social-media",
    },
  ],
  Culture: [
    { label: "Architecture", href: "/tags/architecture" },
    { label: "Arts", href: "/tags/arts" },
    { label: "Death", href: "/tags/death" },
    { label: "Festival", href: "/tags/festival" },
    { label: "Food", href: "/tags/food" },
    { label: "Heritage & Tradition", href: "/tags/tradition" },
    { label: "Language", href: "/tags/language" },
    { label: "Music", href: "/tags/music" },
    { label: "Nature", href: "/tags/nature" },
    { label: "Philosophy", href: "/tags/philosophy" },
  ],
  Videos: [
    { label: "Explainers", href: "/tags/explainers" },
    { label: "Shorts", href: "/tags/shorts" },
    {
      label: "ThinkChina Conversations",
      href: "/tags/thinkchina-conversations",
    },
    { label: "ThinkChina Forum", href: "/tags/thinkchina-forum" },
    {
      label: "Vox Pops",
      href: "/tags/vox-pop",
    },
  ],
};

export const categoryNavLinks: {
  label: string;
  hasDropdown: boolean;
  href: string;
}[] = [
  { label: "Regional", hasDropdown: true, href: "/regional" },
  { label: "Politics", hasDropdown: true, href: "/politics" },
  { label: "Economy", hasDropdown: true, href: "/economy" },
  { label: "Technology", hasDropdown: true, href: "/technology" },
  { label: "History", hasDropdown: true, href: "/history" },
  { label: "Society", hasDropdown: true, href: "/society" },
  { label: "Culture", hasDropdown: true, href: "/culture" },
  { label: "Cartoon", hasDropdown: false, href: "/cartoon" },
  { label: "Videos", hasDropdown: true, href: "/tags/video" },
];

/** Single-segment hrefs (e.g. /culture) use level1; multi-segment (e.g. /tags/video) match pathname. */
export function isCategoryNavItemActive(
  pathname: string,
  level1: string,
  level2: string,
  category: { href: string },
): boolean {
  const hrefPath = category.href.split("?")[0];
  const hrefSegments = hrefPath.split("/").filter(Boolean);

  if (hrefSegments.length === 1) {
    return level1 === hrefSegments[0] && !level2;
  }

  const normalized = pathname.split("?")[0];
  return normalized === hrefPath || normalized.startsWith(`${hrefPath}/`);
}
